import { render, staticRenderFns } from "./DialogUpdateUserGroup.vue?vue&type=template&id=22a176a6&scoped=true&"
import script from "./DialogUpdateUserGroup.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./DialogUpdateUserGroup.vue?vue&type=style&index=0&id=22a176a6&lang=scss&scoped=true&"
import style1 from "./DialogUpdateUserGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a176a6",
  null
  
)

export default component.exports